import { entityType } from "./history.models";

export class GetHistory {
  static readonly type = "[History] Get history";
  constructor(public entityType: entityType, public profileId?: string) {}
}
